"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentTransition = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var transition_1 = require("./transition");
var lazy_transition_1 = require("./lazy-transition");
exports.ComponentTransition = function (props) {
    var lazy = props.lazy;
    if (lazy) {
        return react_1.default.createElement(lazy_transition_1.LazyTransition, tslib_1.__assign({}, props));
    }
    return react_1.default.createElement(transition_1.Transition, tslib_1.__assign({}, props));
};
exports.ComponentTransition.displayName = "ComponentTransition";
